const platformColors = {
  primary: '#40756d',
  secondary: '#EBECF0', //hover
  error: '#EB6868',
  //custom colors//
  //gray
  grayf8: '#F8F8F8', // v-app
  grayf4: '#F4F5F8',
  grayf5: '#F5F5F5',
  graybe: '#bebebe',
  gray9a: '#9C9C9A',
  gray74: '#747474',
  //blue
  blueff: "#0069FF",
  bluefa: "#35A8FA",
  //black and white
  black: '#000000',
  white: '#FFFFFF',
  //platform and program
  contrast: '#FFFFFF',
  navigation: '#F0F0F0',
  //state colors
  done: '#BAD371',
  ok: '#BAD371',
  pending: '#CCCCCC',
  executing: '#65B2E2',
  running: '#65B2E2',
  cancelled: '#EB6868',
  progress: '#F5D57E',
  // taxonomia do Design System IDT — texto de pill sobre fundo tintado (contraste) + wash suave do primary
  primaryFaint: '#E8F3F1',
  successDarken: '#2D7A32',
  warningDarken: '#A85700',
  errorDarken: '#A52E2E',
  infoDarken: '#0B6CAD',
  neutralText: '#5B5B5B',
  textPrimary: '#2E2E2E'
}
const platformDarkColors = {
  primary: '#4cc7b4',
  secondary: '#4F4F4F', //hover
  accent: '#389485',
  error: '#FF7F7F',
  // Gray
  grayf8: '#2D2D2D',
  grayf4: '#292929',
  grayf5: '#303030',
  graybe: '#8C8C8C',
  gray9a: '#A1A1A1',
  gray74: '#FAFAFA',
  // Blue
  blueff: "#00C3FF",
  bluefa: "#54B0EA",
  // Black and white
  black: '#000000',
  white: '#F0F0F0',
  //platform and program
  contrast: '#353535',
  navigation: '#252525',
  // State colors
  done: '#BAD371',
  ok: '#BAD371',
  pending: '#CCCCCC',
  executing: '#65B2E2',
  running: '#65B2E2',
  cancelled: '#FF7F7F',
  progress: '#F5D57E',
  // taxonomia do Design System IDT — texto de pill sobre fundo tintado (contraste) + wash suave do primary
  primaryFaint: '#14241F',
  successDarken: '#7ED081',
  warningDarken: '#FFB454',
  errorDarken: '#F3A0A0',
  infoDarken: '#7CC6FF',
  neutralText: '#B6B8BD',
  textPrimary: '#E7E8EB'
}

export default {
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes: {
      //overwrite themes default from vuetify
      light: platformColors,
      dark: platformDarkColors
    }
  },
  icons: {
    iconfont: 'md',
  }
}
